module.exports = __webpack_public_path__ + "static/media/Santorini.988d73a8.jpg";